<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
      ref="filterRef"
      :filters="filtersConfig"
      :display-advanced="false"
      search-text=""
      v-model="filterModel"
    >
      <div
        class="col d-flex flex-column align-items-center justify-content-start my-1"
      >
        <action-button
          id="process-specialist-absences-search"
          i="fa fa-sync"
          variant="success"
          type="button"
          @click="onProcessHandler"
        >
          Procesar
        </action-button>
      </div>
    </filter-manager>
  </div>
</template>
<script>
//libs components
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import ActionButton from 'ActionButton';

//services
import AcademicYearServices from '@/services/api/academicyear.api';
import ProviderServices from '@/services/api/provider.api';
import SpecialistServices from '@/services/api/specialist.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'SpecialistAbsencesReport',
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
  },
  mixins: [alertMixin],
  data: () => ({
    currentAcademicYear: null,
    filterOptions: {
      providers: [],
      municipalities: [],
      months: [],
      specialists: [],
    },
    filterModel: {
      provider: null,
      municipality: null,
      month: null,
      specialist: null,
    },
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Informe de Ausencia',
        routes: ['Informes', 'Informe de Ausencia'],
      };
    },
    userHasSingleCompany() {
      return this.userCompanies?.length === 1;
    },
    userCurrentCompany() {
      return this.userHasSingleCompany ? this.userCompanies[0] : null;
    },
    disabledFilterByProvider() {
      return this.userHasSingleCompany && !!this.filterModel.provider?.id;
    },
    filtersConfig() {
      return [
        {
          name: 'provider',
          component: 'custom-drop-down',
          class: 'col-12 col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Proveedor',
          error: 'El proveedor es requerido.',
          validations: 'required',
          clearable: false,
          options: this.filterOptions.providers,
          disabled: this.disabledFilterByProvider,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          class: 'col-12 col-md-2',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Municipio',
          error: 'El municipio es requerido.',
          validations: 'required',
          options: this.filterOptions.municipalities,
          disabled: this.filterOptions.municipalities.length === 1,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          class: 'col-12 col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Especialista',
          options: this.filterOptions.specialists,
          disabled: this.filterOptions.specialists.length === 1,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-12 col-md-2',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Mes',
          options: this.filterOptions.months,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      await AcademicYearServices.getCurrentAcademicYear().then(
        (res) => (this.currentAcademicYear = res.data)
      );
      await this.getProviders();
      await this.getMonths();
    },
    async getProviders() {
      await ProviderServices.getAllProvidertCompaniesByYear({
        academicYearId: this.currentAcademicYear.id,
      }).then((res) => (this.filterOptions.providers = res.data));
      this.filterModel = {
        ...this.filterModel,
        provider: this.userCurrentCompany,
      };
      if (this.userHasSingleCompany) {
        await this.getMunicipalities();
        await this.getSpecialists();
      }
    },
    async getMunicipalities() {
      await SpecialistServices.getProviderMunicipalities(
        this.filterModel.provider?.id
      ).then((res) => {
        this.filterOptions.municipalities = res.data;
        if (res.data.length === 1) {
          this.filterModel.municipality = res.data[0];
        }
      });
    },
    async getSpecialists() {
      await SpecialistServices.getSpecialistProvider({
        academicYearId: this.currentAcademicYear.id,
        companyId: this.filterModel.provider?.id,
      }).then((res) => {
        this.filterOptions.specialists = res.data;
        if (res.data.length === 1) {
          this.filterModel.specialist = res.data[0];
        }
      });
    },
    async getMonths() {
      await AcademicYearServices.getMonthsInAcademicYear(
        this.currentAcademicYear.id
      ).then((res) => (this.filterOptions.months = res.data));
    },
    async onChangeProvider() {
      this.cleanSpecialist();
      this.cleanMunicipality();
      await this.getMunicipalities();
      await this.getSpecialists();
    },
    cleanSpecialist() {
      this.filterModel.specialist = null;
    },
    cleanMunicipality() {
      this.filterModel.municipality = null;
    },
    async onProcessHandler() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) return;
      await ReportServices.getReport('specialistabsencesreport', {
        academicYearId: this.currentAcademicYear.id,
        providerId: this.filterModel.provider?.id,
        municipalityId: this.filterModel.municipality?.id,
        specialistId: this.filterModel.specialist?.id,
        month: this.filterModel.month?.id,
      })
        .then((res) => {
          DocumentServices.Download(res.data);
        })
        .catch((err) => {
          const error =
            err.response?.data?.message ??
            'Error al intentar cargar el reporte';
          this.ShowToast('Error', error, 'error');
        });
    },
  },
};
</script>
